/* eslint-disable sort-imports */
import React from 'react'
import {assignOldestTranscript} from 'api/action/assignOldestTranscript'
import {SidebarQueueProps} from './types'
import SidebarQueueView from './SidebarQueueView'
import {toast} from 'components/Toast'
import {
    useAppDispatch,
} from 'hooks'
import {useQueues} from '../../../hooks/ninchat'
import {getAssignOldestTranscriptErrorMessage} from 'utils/assignOldestTranscriptError'
import {useTranslation} from 'react-i18next'

const SidebarQueue = (props: SidebarQueueProps): React.ReactElement | null => {
    const {
        queue_id,
        onToggleQueue,
        loadQueue,
        loadQueueSettings,
        loadQueueStatistics,
        onAcceptAudience,
        nestedSidebar,
    } = props
    const dispatch = useAppDispatch()
    const {t} = useTranslation()
    const [loading, setLoading] = React.useState(false)

    const currentQueue = useQueues([queue_id].filter((id) => Boolean(id)))?.[queue_id] ?? {}
    const isSelected = !history.state?.route?.params?.audience_id && history.state?.route?.params?.queue_id === queue_id

    const onAssignOldestTranscript = (): void => {
        setLoading(true)

        dispatch(assignOldestTranscript({queue_id}))
            .unwrap()
            .then(() => {
                toast.success(t('Assigned'))
                setLoading(false)
            }, (error) => {
                toast.error(getAssignOldestTranscriptErrorMessage(error, t))
                setLoading(false)
            })
    }

    // if queue is part of group, do not show it in sidebar
    if (currentQueue.queue_attrs.group_id) {
        return null
    }

    return currentQueue
        ? (
            <SidebarQueueView
                isSelected={isSelected}
                loadQueue={loadQueue}
                loadQueueSettings={loadQueueSettings}
                loadQueueStatistics={loadQueueStatistics}
                loading={loading}
                nestedSidebar={nestedSidebar}
                onAcceptAudience={onAcceptAudience}
                onAssignOldestTranscript={onAssignOldestTranscript}
                onToggleQueue={onToggleQueue}
                queue_attrs={currentQueue.queue_attrs}
                queue_id={queue_id}
                queue_settings={currentQueue.queue_settings}
            />
        )
        : null
}

export default SidebarQueue
